import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { auth } from "../../config/firebase";
import { signOut, onAuthStateChanged } from "firebase/auth";

const Header = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [userEmail, setUserEmail] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setUser(user);
      if (user) {
        setUserEmail(user.email);
      }
    });

    return () => unsubscribe();
  }, []);

  const handleSignOut = async () => {
    await signOut(auth);
    navigate('/');
  };

  return (
    <nav className="p-4">
      <div className="max-w-7xl mx-auto flex justify-between items-center">
        <Link to="/">
          <img
            src="/logo.svg"
            alt="Text2Block"
            className="h-8 cursor-pointer"
          />
        </Link>
        {user ? (
          <div className="flex items-center gap-4">
            <Link
              to="/contact-us"
              className="px-4 py-2 text-white hover:bg-gray-700 rounded-lg transition-colors"
            >
              Contact Us
            </Link>
            <Link
              to="/home"
              className="px-4 py-2 text-white hover:bg-gray-700 rounded-lg transition-colors"
            >
              Home
            </Link>
            <span className="text-white">
              Welcome, {userEmail}
            </span>
            <button
              onClick={handleSignOut}
              className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors"
            >
              Sign Out
            </button>
          </div>
        ) : (
          <div className="space-x-4">
            <Link
              to="/contact-us"
              className="px-4 py-2 text-white hover:bg-gray-700 rounded-lg transition-colors"
            >
              Contact Us
            </Link>
            <Link
              to="/sign-in"
              className="px-4 py-2 text-white hover:bg-gray-700 rounded-lg transition-colors"
            >
              Sign In
            </Link>
            <Link
              to="/sign-up"
              className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
            >
              Sign Up
            </Link>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Header;